<template>
  <a-modal :visible="visible" okText="开始添加" :width="600" @ok="handleCreate" cancellText="取消" @cancel="visible = false"
    title="添加僵尸粉">
    <!-- <a-alert :style="{ marginBottom: '15px' }" message="每次删除操作建议不要超过总好友数量的15%,误操作引起的账号问题，与平台无关"></a-alert> -->
    <a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-form-item label="添加好友时间间隔" :wrapperCol="wrapperCol">
        <a-input-number :min="0" :formatter="value => `${value}秒`"
          v-decorator="['min_time', { initialValue: 15, rules: [{ required: true, message: '必填项' }] }]">
        </a-input-number>
        -
        <a-input-number :min="0" :formatter="value => `${value}秒`"
          v-decorator="['max_time', { initialValue: 30, rules: [{ required: true, message: '必填项' }] }]">
        </a-input-number>
      </a-form-item>
      <a-form-item label="本次添加人数">
        <a-input-number :min="0"
          v-decorator="['num', { initialValue: 1, rules: [{ required: true, message: '必填项' }] }]" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import FansApi from '@/api/fans'
import { mapActions, mapGetters } from 'vuex'
import { log } from 'console'
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      visible: false,
      currentRobotId: 0,
      labelCol: {
        span: 8,
      },
      wrapperCol: {
        span: 12
      },
      badge: [
        '[昵称]'
      ],
      tableData: this.loadData
    }
  },
  props: {
    loadData: {
      type: Array,
      default: []
    }
  },
  watch:{
    loadData: {
      deep: true,
      handler(newVal, oldVal){
        // console.log(newVal)
        this.tableData = newVal
      }
    }
  },
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG']),
    show(currentRobotId) {
      this.visible = true
      // console.log('父组件拿到的表格的数据==',this.tableData)
      this.currentRobotId = currentRobotId
    },
    handleCreate() {
      // console.log('this.tableData111111=', this.tableData)
      // 过滤掉状态为5和6的wxid
      this.tableData = this.tableData.filter(item => {
        return item.del !== '5' && item.del !== '6'
      })
      // console.log('this.tableData22222=', this.tableData)
      this.form.validateFields((err, values) => {
        // 如果表格中不是状态5、6的个数 < 用户输入的个数, 则以表格中的个数为准
        values.num = this.tableData.length < values.num ? this.tableData.length : values.num
        // console.log(`选中的僵尸粉的个数=${values.num}`)
        if (values.num !== 0) {
          let wxidList = []
          for (let i = 0; i < values.num; i++) {
            wxidList.push(this.tableData[i].wxid)
          }
          let wxid = wxidList.join(',')
          // console.log(`给后台传个字符串wxid=${wxid}`)
          let parameter = {
            sub_id: this.currentRobotId,
            num: values.num,
            wxid: wxid
          }
          // console.log('给接口的参数=', parameter)
          // 添加僵尸粉的接口
          FansApi.addInactive(parameter)

          // 向机器人发送消息
          this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
            robotid: this.currentRobotId,
            type: 'die_fans_add',
            data: values
          }).then(result => {
            this.$message.success('发送指令成功')
            this.visible = false
          })
        } else {
          this.$message.success('所有僵尸粉均已添加')
          this.visible = false
        }
      })
    }
  }
}
</script>